import "slick-carousel";
import { resizeBackgroundImages } from "../responsive-images";

const $slides = $(".slider-fullscreen .slider__slides");

$slides.each(function() {
  const $this = $(this);
  const sliderImages = document
    .querySelector(".slider-fullscreen")
    .querySelectorAll(".responsive-background-image");

  $this.slick({
    dots: true,
    arrows: true,
    speed: 500,
    centerMode: false,
    variableWidth: false,
    adaptiveHeight: false,
    autoplay: false,
    autoplaySpeed: 10000
  });

  $this.on("afterChange", function(slick, currentSlide) {
    setTimeout(function() {
      resizeBackgroundImages(sliderImages);
    }, 1000);
  });
});
